import React from 'react';

function DiscountCouponIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width={24} {...props}>
      <path d="M12 21.6l-3.106 1.991L7.2 20.314l-3.685.171.171-3.685L.41 15.106 2.4 12 .409 8.894 3.686 7.2l-.171-3.685 3.685.171L8.894.41 12 2.4 15.106.409 16.8 3.686l3.685-.171-.171 3.685 3.277 1.694L21.6 12l1.991 3.106-3.277 1.694.171 3.685-3.685-.171-1.694 3.277L12 21.6zm-.809-11.112c0-.86-.176-1.52-.53-1.983-.353-.463-.86-.694-1.52-.694-1.348 0-2.022.892-2.022 2.677 0 .875.176 1.544.527 2.007.352.463.85.694 1.495.694.672 0 1.181-.225 1.529-.676.348-.451.521-1.126.521-2.025zm-2.595.012c0-.496.044-.864.132-1.104.087-.24.229-.36.424-.36.375 0 .563.487.563 1.464 0 .984-.188 1.477-.563 1.477-.195 0-.337-.123-.424-.367-.088-.244-.132-.614-.132-1.11zm8.595 3.41c0-.86-.176-1.52-.53-1.983-.353-.463-.86-.695-1.52-.695-1.348 0-2.022.893-2.022 2.678 0 .871.176 1.538.527 2.001.352.463.85.694 1.495.694.672 0 1.181-.225 1.529-.676.348-.451.521-1.124.521-2.019zm-2.595.012c0-.496.044-.864.132-1.105.087-.24.229-.36.424-.36.375 0 .563.488.563 1.465 0 .984-.188 1.476-.563 1.476-.195 0-.337-.122-.424-.366-.088-.244-.132-.614-.132-1.11zm.627-5.988h-1.407L9.064 16.5h1.407l4.752-8.566z" />
    </svg>
  );
}

export default DiscountCouponIcon;



// WEBPACK FOOTER //
// ./src/site-render/src/icons/DiscountCouponIcon.js